class EditSellingCardBlockReq{
    constructor(){
        this.id = null;
        this.sellingCardId = null;
        this.content = null;
        this.title = null;
    }
}
export default EditSellingCardBlockReq